import { request } from '../utils/http'

export const createMessage = (payload) => request('/api/message', {
  method: 'POST',
  body: payload,
  showSuccessMessage: false
})

export const getReceivedMessages = (params = {}) => {
  const search = new URLSearchParams()
  if (params.pageNum) search.set('pageNum', String(params.pageNum))
  if (params.pageSize) search.set('pageSize', String(params.pageSize))
  const query = search.toString()
  return request(`/api/message/received${query ? `?${query}` : ''}`)
}

export const getSentMessages = (params = {}) => {
  const search = new URLSearchParams()
  if (params.pageNum) search.set('pageNum', String(params.pageNum))
  if (params.pageSize) search.set('pageSize', String(params.pageSize))
  const query = search.toString()
  return request(`/api/message/sent${query ? `?${query}` : ''}`)
}

export const releaseMessage = (id) => request(`/api/message/release/${id}`, {
  method: 'POST',
  showSuccessMessage: false
})

export const readMessage = (id) => request(`/api/message/read/${id}`, {
  method: 'PUT',
  showSuccessMessage: false
})

export const deleteMessage = (id) => request(`/api/message/${id}`, {
  method: 'DELETE',
  showSuccessMessage: false
})
